import { render } from "./protocol_inside_winners_down.vue?vue&type=template&id=52152815&scoped=true"
import script from "./protocol_inside_winners_down.vue?vue&type=script&lang=js"
export * from "./protocol_inside_winners_down.vue?vue&type=script&lang=js"

import "./protocol_inside_winners_down.vue?vue&type=style&index=0&id=52152815&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52152815"],['__file',"vue/js/components/sale/protocol/inside/block/protocol_inside_winners_down.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52152815"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52152815', __exports__)) {
    console.log('reload')
    api.reload('52152815', __exports__)
  }
  
  module.hot.accept("./protocol_inside_winners_down.vue?vue&type=template&id=52152815&scoped=true", () => {
    console.log('re-render')
    api.rerender('52152815', render)
  })

}


export default __exports__